var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78a0cf",
    d: "M13 27A2 2 0 1 0 13 31A2 2 0 1 0 13 27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M77 12A1 1 0 1 0 77 14A1 1 0 1 0 77 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cee1f4",
    d: "M50 13A37 37 0 1 0 50 87A37 37 0 1 0 50 13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M83 11A4 4 0 1 0 83 19A4 4 0 1 0 83 11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#78a0cf",
    d: "M87 22A2 2 0 1 0 87 26A2 2 0 1 0 87 22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M81 74A2 2 0 1 0 81 78 2 2 0 1 0 81 74zM15 59A4 4 0 1 0 15 67 4 4 0 1 0 15 59z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#78a0cf",
    d: "M25 85A2 2 0 1 0 25 89A2 2 0 1 0 25 85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 51A2.5 2.5 0 1 0 18.5 56A2.5 2.5 0 1 0 18.5 51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M21 66A1 1 0 1 0 21 68A1 1 0 1 0 21 66Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 33A1 1 0 1 0 80 35A1 1 0 1 0 80 33Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcba7f",
    d: "M27.05,70.3c-0.744,0-1.35-0.612-1.35-1.366V32.066c0-0.754,0.605-1.366,1.35-1.366h45.9 c0.744,0,1.35,0.612,1.35,1.366v36.867c0,0.754-0.605,1.366-1.351,1.366H27.05z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M72.95,31.4c0.358,0,0.65,0.299,0.65,0.666v36.868c0,0.367-0.292,0.666-0.651,0.666H27.05 c-0.358,0-0.65-0.299-0.65-0.666V32.066c0-0.367,0.292-0.666,0.65-0.666H72.95 M72.95,30h-45.9C25.918,30,25,30.925,25,32.066 v36.868C25,70.075,25.918,71,27.05,71h45.899C74.082,71,75,70.075,75,68.934V32.066C75,30.925,74.082,30,72.95,30L72.95,30z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c7dff1",
    d: "M29.583 34.5H70.5V66.5H29.583z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M69.708,35h-2.583c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.583c0.276,0,0.5,0.224,0.5,0.5 S69.984,35,69.708,35z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M63.125,35h-5.938c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h5.938c0.276,0,0.5,0.224,0.5,0.5 S63.401,35,63.125,35z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M71,67H29.083V34h24.729c0.276,0,0.5,0.224,0.5,0.5s-0.224,0.5-0.5,0.5H30.083v31H70V38 c0-0.276,0.224-0.5,0.5-0.5S71,37.724,71,38V67z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9e65c",
    d: "M41.5 38A3.5 3.5 0 1 0 41.5 45A3.5 3.5 0 1 0 41.5 38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M41.5,45.25c-2.067,0-3.75-1.683-3.75-3.75s1.683-3.75,3.75-3.75s3.75,1.683,3.75,3.75 S43.567,45.25,41.5,45.25z M41.5,38.25c-1.792,0-3.25,1.458-3.25,3.25s1.458,3.25,3.25,3.25s3.25-1.458,3.25-3.25 S43.292,38.25,41.5,38.25z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00a7a7",
    d: "M38.264,66.128L53.59,43.437c0.308-0.454,0.991-0.46,1.306-0.011L69.96,64.829v1.299 C69.96,66.128,38.264,66.128,38.264,66.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M70.46,66.629H37.323l15.853-23.472c0.238-0.35,0.635-0.561,1.062-0.563 c0.411-0.038,0.826,0.201,1.068,0.546L70.46,64.671V66.629z M39.206,65.629H69.46v-0.642L54.487,43.715 c-0.078-0.112-0.191-0.138-0.242-0.121c-0.048,0-0.166,0.013-0.242,0.125L39.206,65.629z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00a7a7",
    d: "M30.122,57.014l6.869-7.567c0.447-0.492,1.246-0.454,1.641,0.077l5.571,7.489l-5.939,9.114h-8.224 L30.122,57.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M38.534,66.629h-9l0.09-9.81l6.997-7.708c0.315-0.348,0.79-0.533,1.237-0.508 c0.47,0.023,0.898,0.251,1.175,0.624l5.778,7.769L38.534,66.629z M30.544,65.629h7.448l5.601-8.596l-5.362-7.209 c-0.099-0.133-0.252-0.214-0.422-0.222c-0.167-0.018-0.334,0.058-0.447,0.181L30.62,57.21L30.544,65.629z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00a7a7",
    d: "M59.304,49.374l5.17-6.08c0.348-0.408,0.987-0.378,1.293,0.062l4.192,6.018l-0.043,15.292 L59.304,49.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M70.413,66.258L58.674,49.343l5.419-6.373c0.268-0.314,0.656-0.479,1.069-0.462 c0.41,0.021,0.78,0.226,1.016,0.563l4.281,6.146L70.413,66.258z M59.934,49.405l9.487,13.671l0.038-13.546l-4.103-5.888 c-0.077-0.112-0.187-0.134-0.244-0.136c-0.065-0.009-0.17,0.009-0.258,0.111L59.934,49.405z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#42210b",
    d: "M50 22A2 2 0 1 0 50 26A2 2 0 1 0 50 22Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M59,31.125c-0.104,0-0.207-0.031-0.297-0.098L50,24.621l-8.703,6.406 c-0.224,0.164-0.535,0.117-0.699-0.105s-0.116-0.536,0.105-0.699L50,23.379l9.297,6.844c0.222,0.163,0.27,0.477,0.105,0.699 C59.305,31.055,59.153,31.125,59,31.125z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.b63551b56e5c686dd7cf863ed7d50f91.svg";
export { ForwardRef as ReactComponent };